import React, { useContext,useEffect } from "react";
import { isMobile } from "react-device-detect";
import Back from "../../../components/SVGComponents/Tools/Back";
import DeeptekLogo from "../../../components/SVGComponents/Logo/DeeptekLogo";
import TopToolbar from "../../StudyViewer/Components/Toolbar/TopToolbar";
import {
  ADVANCE_VIEWER_MODALITIES,
  SHOW_NOT_ORIGNAL_MODALITY_LIST,
} from "../../../constants/Constants";
import studyviewerContext from "../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../context/studyviewer/ThumbnailContext";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import AdvanceViewerSwitch from "../../../components/SVGComponents/Tools/AdvanceViewerSwitch";
import ShowOriginal from "../../StudyViewer/Components/Tools/ToolComponents/ShowOriginal";
import DownloadButton from "../../StudyViewer/Components/Tools/ToolComponents/DownloadButton";
import themeContext from "../../../context/theme/ThemeContext";
import { Icon } from "@fluentui/react";
import ShortcutKeyModal from "../../StudyViewer/Components/ShortcutKeyModal/ShortcutKeyModal";

const SharedTopBar = (props) => {
  const { studyModality, advViewerUser,setShowShortcutModal ,showShortcutModal  } = useContext(studyviewerContext);
  const { activeModality } = useContext(ThumbnailContext);
  const { theme,themeName } = useContext(themeContext);

  if (isMobile) {
    return (
      <>
        <div
          className="topbar-container w100"
          style={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="topbar-buttons">
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                padding: "0px 5px",
              }}
              onClick={() => window.close()}
            >
              <Back />
            </div>
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                paddingLeft: "10px",
              }}
            >
              {/* <Augmento /> */}
              <DeeptekLogo />
            </div>
          </div>

          <div
            className="topbar-buttons cursor-pointer"
            style={{
              paddingRight: "10px",
            }}
          >
            {(!props.advanceViewer || !props.advanceViewerAvailable) && (
              <TopToolbar
                openSeries={props.openSeries}
                seriesMenu={props.seriesMenu}
              />
            )}
            {advViewerUser && process.env.REACT_APP_VDC_PLATFORM != "true" && (!props.advanceViewer || !props.advanceViewerAvailable) && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <div
                  className={
                    isMobile ? "highlight-tool-mobile" : "highlight-tool"
                  }
                  onClick={() => {
                    props.setAdvanceViewer(true);
                  }}
                  aria-describedby="series-selector"
                  style={{
                    width: "60px",
                    height: isMobile ? "50px" : "30px",
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  <AdvanceViewerSwitch color={theme.palette.inactiveTool} />
                  <span
                    style={{
                      fontSize: "8px",
                      lineHeight: "100%",
                      fontWeight: "400",
                      color: "var(--mobile-color-txt)",
                      marginTop: "3px",
                    }}
                  >
                    Advance Viewer
                  </span>
                </div>
              </div>
            )}

            {process.env.REACT_APP_VDC_PLATFORM != "true" && props.advanceViewer && props.advanceViewerAvailable && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <div
                  className={
                    isMobile ? "highlight-tool-mobile" : "highlight-tool"
                  }
                  onClick={() => {
                    props.setAdvanceViewer(false);
                  }}
                  aria-describedby="series-selector"
                  style={{
                    width: "60px",
                    height: isMobile ? "50px" : "30px",
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  <AdvanceViewerSwitch color={theme.palette.inactiveTool} />
                  <span
                    style={{
                      fontSize: "8px",
                      lineHeight: "100%",
                      fontWeight: "400",
                      color: "var(--mobile-color-txt)",
                      marginTop: "3px",
                    }}
                  >
                    Basic Viewer
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="topbar-container w100">
          <div className="topbar-augmento-logo ">
            <DeeptekLogo />
          </div>
          <div className="topbar-toolbar-container">
            {(!props.advanceViewer || !props.advanceViewerAvailable) && (
              <>
                <div className="topbar-toolbar-left-container">
                  <TopToolbar
                    openSeries={props.openSeries}
                    seriesMenu={props.seriesMenu}
                  />
                  <div className="highlight-tool cursor-pointer" style={{ marginLeft: "5px" }}>
                    <CustomToolTipHost content={"Shortcut Information"} id="Shortcut">
                      <span className="topbar-toolbar-right-icons" 
                      onClick={() => {
                        console.log("Shortcut Icon Clicked");
                        setShowShortcutModal(true);
                        }}>
                        <Icon iconName="info" style={{ fontSize: "18px", marginTop: "2px", color: theme.palette.inactiveTool }} />
                      </span>
                    </CustomToolTipHost>
                  </div>
                </div>
              </>
            )}

            <div className="topbar-toolbar-right-container h100">
              {
                <>
                  {/* {ADVANCE_VIEWER_MODALITIES.includes(studyModality) && ( */}
                  {advViewerUser && process.env.REACT_APP_VDC_PLATFORM != "true" && (!props.advanceViewer || !props.advanceViewerAvailable) && (
                    <span
                      style={{
                        display: "flex",
                        margin: "0px 5px",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onClick={() => {
                        props.setAdvanceViewer(true);
                      }}
                    >
                      <div className="highlight-tool">
                        <CustomToolTipHost
                          content={"Switch to Advance Viewer"}
                          id="advance-viewer"
                        >
                          <span className="topbar-toolbar-right-icons">
                            <AdvanceViewerSwitch color={"#bfbfbf"} />
                          </span>
                        </CustomToolTipHost>
                      </div>
                    </span>
                  )}

                  {process.env.REACT_APP_VDC_PLATFORM != "true" && props.advanceViewer && props.advanceViewerAvailable && (
                    <span
                      style={{
                        display: "flex",
                        margin: "0px 5px",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onClick={() => {
                        props.setAdvanceViewer(false);
                      }}
                    >
                      <div className="highlight-tool">
                        <CustomToolTipHost
                          content={"Switch to Basic Viewer"}
                          id="basic-viewer"
                        >
                          <span className="topbar-toolbar-right-icons">
                            <AdvanceViewerSwitch  color={"#bfbfbf"} />
                          </span>
                        </CustomToolTipHost>
                      </div>
                    </span>
                  )}
                  {/* )} */}
                  {showShortcutModal && <ShortcutKeyModal isSharedStudyViewer={false}/>}
                </>
              }
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default SharedTopBar;
